import React from "react";
import useDocumentTitle from "@/components/ui/common/document-title";
import SRBReportTable from "./table";

export default function SRBReport() {
  useDocumentTitle("SRB Report");

  return (
    <div className="w-full p-5 space-y-6">
      <div className="space-y-6">
        <SRBReportTable />
      </div>
    </div>
  );
}